module.exports = __webpack_public_path__ + "img/Ford-SRS-111921-DealerDraft-Playful.6c60805f.jpeg";